import React, { PropTypes } from 'react';

import Icon from './Icon';

import './Filter.css';

const propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

const Filter = ({ value, onChange }) => {
  const handleClear = event => {
    onChange('');
  };

  const handleChange = event => {
    onChange(event.target.value);
  };

  return (
    <div className="Filter">
      <input type="text" placeholder="Filter..." value={value} onChange={handleChange} autoCapitalize="none" autoCorrect="off" />
      {value && <Icon id="circle-cross" onClick={handleClear} />}
    </div>
  );
};

Filter.propTypes = propTypes;

export default Filter;



/** WEBPACK FOOTER **
 ** ./src/components/Filter.js
 **/